import React from 'react'

import Stack from 'components/Stack/Stack'
import IconView from 'components/v2/IconView/IconView'
import Heading from 'components/v2/Heading/Heading'
import PageSection from 'components/v2/PageSection/PageSection'
import CourseTargetAudienceCard, {CourseTargetAudienceCardProps} from 'components/v2/CourseTargetAudienceCard/CourseTargetAudienceCard'
import Image from 'components/Image/Image'
import useMediaQuery from 'common/useMediaQuery'

const TargetAudienceSection = () => {
  const {isTablet} = useMediaQuery()
  const items: CourseTargetAudienceCardProps[] = [
    {
      image: 'checkbox',
      description: 'Государственные служащие'
    },
    {
      image: 'computer',
      description: 'Муниципальные служащие'
    },
    {
      image: 'chart',
      description: 'Все, кто хочет улучшить понимание принципов работы государственных и муниципальных органов власти'
    }
  ]

  return (
    <PageSection variant='white-icons'>
      <Stack gap={134} orientation='horizontal' tabletOrientation='vertical'>
        <Stack gap={60}>
          <Heading variant='2'>Для кого курс?</Heading>
          <IconView
            cols={2}
            tabletCols={2}
            phoneCols={1}
            columnGap={20}
            rowGap={20}
          >
            {items.map((item, index) => {
              return <CourseTargetAudienceCard key={index} animateDelayIndex={index} {...item} />
            })}
          </IconView>
        </Stack>
        <Image
          width={isTablet ? 'auto' : '25%'}
          src='/static/img/pages/program-registry/digital-development/target-audience-section/section-image.svg'
        />
      </Stack>
    </PageSection>
  )
}

export default TargetAudienceSection
